// Settings/features only — AI bot and instruction actions live in redux/customBots.
const actions = {
  SET_STATE: 'ai/SET_STATE',
  GET_SETTINGS: 'ai/GET_SETTINGS',
  UPDATE_SETTINGS: 'ai/UPDATE_SETTINGS',
  AI_LIST: 'ai/AI_LIST',
  UPDATE_AI_FEATURE: 'ai/UPDATE_AI_FEATURE',
}

export default actions
